import type { CreateContextualButtonOptions } from '../models/CreateContextualButtonOptions';
import { bootstrap } from '../../apps/product-contextual-menu/ProductContextualMenuApp';

/**
 * Create a Brilliant contextual button. This button will show contextual utilities for the user when clicked.
 */
export function createProductContextualButton(
    options: CreateContextualButtonOptions
): void {
    const { productId, parent, marginTop, marginRight } = options;
    if (!productId) {
        throw new Error(
            'Brilliant: productId is required to create a contextual button.'
        );
    }

    parent.prepend(document.createElement('div'));
    bootstrap(
        parent,
        productId,
        [
            'product-detail',
            'toggle-product-comparison-selection',
            'product-search-similar',
            'product-search-combinations',
            'product-mix-and-match'
        ],
        marginTop,
        marginRight
    );
}
